import { dcNavigationTreeGeneric } from './dcNavigationtree.model';
import { dcTag } from './dcTag.model';

//export class dcTreeNode implements TreeModel {
export class dcTreeNode extends dcNavigationTreeGeneric<dcTreeNode> {
  public ElementTemplateName: string;
  public Description?: string;
  public ElementDescription?: string;
  public HierarchyPath?: string;
  public HierarchyClassification?: number;
  public Tags?: dcTag[];
  public NodeVersionID?: number;
  public ParentNodeVersionID?: number;
  public ValueTypeID?: number;
  public HierarchyRuleId?: number;
  public ParentHierarchyRuleId?: number;
  public ElementTypeID?: number;
  public ElementTypeName?: string;
  public NoOfInstances?: number;
  public IsMandatory?: boolean;
  public StatusMessage?: string;
  public Level?: number;
  public isNewNode? = false;
  public isDelete? = false;
  public ParentName?: string;
  public id?: number;
  public name: string;
  public NamingPattern?: string;
  public tooltipText?: string;
  public cssClass?: string;
  public AllowInstanceOfSameType?: boolean;
  public IsSingleton?: boolean;
  public RuleRootElementVersionID?: number;
  public RuleElementVersionID?: number;
  public RuleElementPath?: string;
  public EventCategoryID?: number;
}
